import GenericDictionaryPage from "./GenericDictionaryPage";
import { getDemandInFormat } from "../api/demandInFormatApi";

export default function DemandInFormat() {
    return (
        <GenericDictionaryPage
            tableKey="demandInFormat"
            fetchData={getDemandInFormat}
            titleKey="genericDic:demandInFormat"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:demandInFormat").toLowerCase()
                })
            }
        />
    );
}
